import React from 'react';
import { useTranslation } from 'react-i18next';

import StyledLink from '../StyledLink';
import './styles.scss';

const AdditionalLinks = ({ links }) => {
  const { t, i18n } = useTranslation();
  const usedLang = i18n.language;
  return (
    <div className="additional-links-wrapper">
      {links.map(({ text, link }, idx) => (
        <StyledLink
          className="additional-link"
          key={idx}
          href={link[usedLang]}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t(text)}
        </StyledLink>
      ))}
    </div>
  );
};

export default AdditionalLinks;
